'use client';

import React from 'react';
import { useI18n } from 'next-localization';

import { ProvidersSearch } from '@/features/landing/components/providers-search';
import { ProviderSearchFields, ProvidersInputRef } from '@/features/landing/landing-search.types';

import { useListingContext } from '../../hooks';

export const SearchFilter = ({
  coids,
  program,
  locationUrlTitle,
  providersInputRef,
}: Pick<ProviderSearchFields, 'coids' | 'program' | 'locationUrlTitle'> & {
  providersInputRef: React.RefObject<ProvidersInputRef>;
}): JSX.Element => {
  const { t } = useI18n();
  const { searchValue, setSearchValue } = useListingContext();

  return (
    <div className="p-1">
      <ProvidersSearch
        label=""
        tip={t('OAS.LandingPage.DoctorClinicCondition')}
        labelHidden
        inputValue={searchValue}
        setInputValue={setSearchValue}
        inputReset={() => setSearchValue(undefined)}
        coids={coids}
        locationUrlTitle={locationUrlTitle}
        program={program}
        ref={providersInputRef}
      />
    </div>
  );
};
